module.exports = __webpack_public_path__ + "img/lv1-1.64dd7b74.png";